import React from "react";
import {observer} from "mobx-react";
import {Station} from "../../services/stations/station.service.interface";
import {DropDownComponent} from "../drop-down/drop-down.component";
import {StationDropDownListModel} from "./models/station-drop-down-list.model";
import {StationDropDownItemModel} from "./models/station-drop-down-item.model";
import {useServices} from "../../hooks/use-services.hook";
import {IFormField} from "../../models/forms/form-field.interface";


interface StationSelectorComponentProps {
    field: IFormField<Station>;
    icon: React.ReactElement;
    placeholder: string;
    getStations: () => Station[];
    renderEmptyListMessage?: () => React.ReactElement | string;
}



export const StationDropDownComponent: React.FC<StationSelectorComponentProps> = observer((props) => {
    const services = useServices();
    const stationsListModel = new StationDropDownListModel({
        services: services,
        onItemSelected: stationDropDownItem => props.field.setValue(stationDropDownItem.station),
        placeholder: props.placeholder,
        allItems: props.getStations().map(s => new StationDropDownItemModel(s)),
        getSelectedItem: () => {
            if(props.field.value) {
                return new StationDropDownItemModel(props.field.value);
            }
            return null;
        }
    });


    return (
        <DropDownComponent field={props.field}
                           icon={props.icon}
                           listViewModel={stationsListModel}
                           renderEmptyListMessage={props.renderEmptyListMessage}
                           />
    );
});
